import React, { Fragment, useState } from "react";
import Radio from '@mui/material/Radio';

const Clasica = () => {
    const [selectedValue, setSelectedValue] = useState("");
    const handleChange = (event) => {
        setSelectedValue(event.target.value);
      };
    return(
        <Fragment>
        <h2>Clasica</h2>
        <br></br>
        <img src="img/tarjeta-amex-clasica.png" alt="clasica"></img>
        <br></br>
        <Radio checked={selectedValue === 'a'} onChange={handleChange} value="a" name="tarjeta" />
        </Fragment>
    )
}

export default Clasica;